import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus";
import FontController from "./controllers/font-controller";
import ExpandController from "./controllers/expand-controller";
import ContentSliderController from "./controllers/content-slider-controller";
import IndexPageHeaderController from "./controllers/index-page-header-controller";
import IosFullHeightController from "./controllers/ios-full-height-controller";
import DialogController from "./controllers/dialog-controller";
import CookieBannerController from "./controllers/cookie-banner-controller";

Turbo.session.drive = false;

const application = Application.start();
application.register("font", FontController);
application.register("expand", ExpandController);
application.register("slider", ContentSliderController);
application.register("index-page-header", IndexPageHeaderController);
application.register("ios-fill-height-controller", IosFullHeightController);
application.register("dialog", DialogController);
application.register("cookie-banner", CookieBannerController)

loadVideo();

async function loadVideo() {
  const videos = document.querySelectorAll("[data-plyr]");

  if (videos && videos.length) {
    let video = await import("./video.js");
    video.init(videos);
  }
}
